import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}

export const actions = {
  findAllPro({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/selectedSubjects/selectProvinceName`, {})
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findYear({ commit }, provinceName) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/selectedSubjects/selectYear`,  { provinceName: provinceName })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findUniversity({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/selectedSubjects/selectUniversityName`, params )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  findMajor({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/selectedSubjects/selectMajorName`, params )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  selectAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/selectedSubjects/selectAll`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  selectMajorAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/selectedSubjects/selectMajor`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  selectSubjectsAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/selectedSubjects/selectSubjectsList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
}

